import React, { useContext } from 'react';
import { translations } from 'src/constants/translations';
import {
  GroupWrapperFiltersAction,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction';
import { GroupWrapper } from 'src/components/profileComponents/Marketplace/components/GroupWrapper';
import {
  GroupWrapperCollapseState,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction/types';
import {
  UnitsCardFooterDefaultEntity,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/components/UnitsCardFooterDefault/components/UnitsCardFooterDefaultEntity';
import { MarketplaceSwitch } from 'src/components/profileComponents/Marketplace/components/Common/MarketplaceSwitch';
import Box from '@mui/material/Box';
import {
  UnitsDataContext,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/context/UnitsDataProvider';

export const UnitsCardFooterDefault: React.FC = () => {
  const context = useContext(UnitsDataContext);
  const [collapseState, setCollapseState] = React.useState<GroupWrapperCollapseState>(GroupWrapperCollapseState.OPEN);

  return (
    <>
      <GroupWrapper
        name={translations.unitsCardFooterDefault}
        actions={(
          <GroupWrapperFiltersAction
            collapseState={collapseState}
            onCollapse={(state) => {
              setCollapseState(state);
            }}
          />
      )}
      />
      { collapseState === GroupWrapperCollapseState.OPEN && context && (
        <>
          <UnitsCardFooterDefaultEntity
            entity={context.state.unitsCard.footer.defaultState.name}
            onChange={(entity) => context.updateState((current) => ({ ...current, unitsCard: { ...current.unitsCard, footer: { ...current.unitsCard.footer, defaultState: { ...current.unitsCard.footer.defaultState, name: entity } } } }))}
            lang={context.state.marketplace.language}
            name={translations.name}
            propertyOptions={context.state.placementPropertyOptions}
            onSwitchChange={(checked) => {
              context.updateState((current) => ({ ...current, unitsCard: { ...current.unitsCard, footer: { ...current.unitsCard.footer, defaultState: { ...current.unitsCard.footer.defaultState, name: { ...current.unitsCard.footer.defaultState.name, isActive: checked } } } } }));
            }}
          />
          <UnitsCardFooterDefaultEntity
            entity={context.state.unitsCard.footer.defaultState.address}
            onChange={(entity) => context.updateState((current) => ({ ...current, unitsCard: { ...current.unitsCard, footer: { ...current.unitsCard.footer, defaultState: { ...current.unitsCard.footer.defaultState, address: entity } } } }))}
            lang={context.state.marketplace.language}
            name={translations.address}
            propertyOptions={context.state.placementPropertyOptions}
            onSwitchChange={(checked) => {
              context.updateState((current) => ({ ...current, unitsCard: { ...current.unitsCard, footer: { ...current.unitsCard.footer, defaultState: { ...current.unitsCard.footer.defaultState, address: { ...current.unitsCard.footer.defaultState.address, isActive: checked } } } } }));
            }}
          />
          <Box display="flex">
            <MarketplaceSwitch
              defaultChecked={context.state.unitsCard.footer.defaultState.logo.isActive}
              title="Logo"
              onChange={(checked) => {
                context.updateState((current) => ({ ...current, unitsCard: { ...current.unitsCard, footer: { ...current.unitsCard.footer, defaultState: { ...current.unitsCard.footer.defaultState, logo: { ...current.unitsCard.footer.defaultState.logo, isActive: checked } } } } }));
              }}
            />
          </Box>
        </>
      )}
    </>
  );
};
